export default {
  testing: 'En Pruebas',
  ready: 'Listo',
  deployed: 'Desplegado',
  obsolete: 'Obsoleto'
}
